<template>
    <div id="app">
        <!--非登录视图-->
        <template v-if="hasBar == 1">
            <siderbar></siderbar>
            <div class="my-container">
                <router-view></router-view>
            </div>
            <div class="clear"></div>
        </template>
        <!--否则只需要登录界面-->
        <router-view v-else></router-view>
    </div>
</template>

<script>
    import siderbar from './components/sideBar.vue';
    export default {
        name: 'app',
        data () {
            return {
                hasBar: sessionStorage.hasBar,
            }
        },
        created(){
            this.hasBar = sessionStorage.hasBar;
        },
        watch: {
            "$route": "setHasBar",
        },
        components:{//引用组件
            siderbar:siderbar,
        },
        methods: {
            setHasBar(){
                this.hasBar = sessionStorage.hasBar;
            },
            logout(){
                this.$router.push({
                    path: '/login'
                })
            }
        }
    }
</script>

<style scoped>
    .my-container{
        height: calc(100vh);
        width: calc(100% - 170px);
        background-color: #F8F9FA;float: left;
    }
</style>
<style type="scss">
    @import "./assets/font-awesome/css/font-awesome.css";
    @media screen and (max-height:670px){.copy-right{display:none;}}/*高度小于100px时 隐藏©*/
    html{
        /*overflow:hidden;*/
        overflow: auto;
    }
    body{
        margin: 0;
        min-width: 1280px;
        font-family:'Microsoft YaHei';
        font-size: 14px;
        color: #626368;
    }
    .shenglue{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .title-bar{
        height: 40px;line-height: 40px;font-size:16.22px;font-weight:bold;color: #409EFF;background-color: #fff;padding-left: 20px;
    }
    .main-content{
        height: calc(100vh - 86px);margin: 8px;padding: 15px 20px;background: #fff;
    }
    ::-webkit-scrollbar {/* 设置滚动条的样式 */
        width: 10px;
        height: 10px;
    }
    ::-webkit-scrollbar-thumb {/* 滚动条滑块 */
        border-radius: 5px;
        background: rgba(0,0,0,0.1);
    }
    .clear{
        clear: both;
    }
    .searchObj .el-range-editor.el-input__inner{
        width: 260px;
    }
    .searchObj .el-date-editor .el-range-separator{
        width: 8% !important;
    }
    /*.el-button--primary {*/
    /*    color: #FFF;*/
    /*    background-color: #1EAFC4!important;*/
    /*    border-color: #1EAFC4!important;*/
    /*}*/
    /*.el-button--primary.is-plain {*/
    /*    color: #1EAFC4!important;*/
    /*    background: #ecf5ff!important;*/
    /*    border-color: #1EAFC4!important;*/
    /*}*/
    /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {*/
    /*    background-color: #1EAFC4!important;*/
    /*    border-color: #1EAFC4!important;*/
    /*}*/
    /*.el-checkbox__inner:hover {*/
    /*    border-color: #1EAFC4!important;*/
    /*}*/
    .el-dialog__body {
        padding: 10px 20px 0 20px!important;
    }
    .el-dialog__footer {
        padding: 0 20px 20px!important;
    }
    .el-notification__content {
        margin-top: 1px!important;
    }
    .tab-click{
        margin-right: 10px;
    }
    .tab-click:last-child{
        margin-right: 0;
    }
    .tab-click:hover{
        text-decoration: underline;
        color: #409EFF;
        cursor: pointer;
    }
    .el-tabs__nav-wrap::after{
        background-color: transparent!important;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 150px;
        line-height:150px!important;
        text-align: center;
    }
     .el-input.is-disabled .el-input__inner{
        color: #0f0f0f!important;
    }
     .el-textarea.is-disabled .el-textarea__inner{
        color: #0f0f0f!important;
    }
    .pic-table .el-table__body-wrapper { /*包含图片的表格需要滚动*/
        overflow-y: auto!important;
    }
    .img-btn{
        cursor: pointer;
    }
    .img-btn:hover{
        opacity: 80%;
    }
    .img-btn:active{
        opacity: 60%;
    }
    .el-radio__label{
        padding-left: 5px!important;
    }
</style>